/* eslint-disable */
import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Grid, Paper, Button, Typography } from '@mui/material';
import {
  btnStyle,
  btnStyleActive,
  forgotHeaderStyle,
  labelStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
} from '../styles';
import { useValidCode } from '../../hooks/useValidCode';
import { useCountDown } from '../../hooks/useCountDown';
import { AuthContext } from '../../contexts/authContext';
import ReactCodeInput from 'react-code-input';
import { AuthPAGES } from '../../constants/pages';
import { Notif } from '../../components/Snackbar/Snackbar';
import { Header } from '../../components/Header/Header';
import { PAGES } from 'src/common/types/pages';

const VerifyAccount: React.FC<any> = () => {
  /* States and context declaration */
  const { code, setCode, codeIsValid } = useValidCode('');
  const authContext = useContext(AuthContext);
  const { email, passwordAdvance } = authContext;
  const navigate = useNavigate();
  const { seconds, setSeconds, setIsActive } = useCountDown(15);
  const [open, setOpen] = React.useState(false);
  const [inProgress, setInProgress] = useState<boolean>(false);

  /* Generic Error Message */
  const [genericErrorMessage, setGenericErrorMessage] = useState('');

  const onReSendCodeCallback = (isReSended: boolean) => {
    if (!isReSended) {
      setGenericErrorMessage('Ooops something was wrong please login again');
      setTimeout(function () {
        navigate(AuthPAGES.signIn);
      }, 4000);
    }
  };

  const onReSendCode = async (e: any) => {
    e.stopPropagation();
    setSeconds(15);
    setIsActive(true);
    if (authContext.mfaRequired)
      try {
        const codeSended = await authContext.reSendMfaCode(
          onReSendCodeCallback
        );
      } catch (error: any) {
        setGenericErrorMessage(error.message);
        setOpen(true);
      }
    else
      try {
        await authContext.reSendCode(email);
        setGenericErrorMessage('Link sent successfully');
        setOpen(true);
      } catch (error: any) {
        setGenericErrorMessage(error.message);
        setOpen(true);
      }
  };

  const sendCode = async (e: any) => {
    e.stopPropagation();
    setInProgress(true);
    if (code) {
      if (code.length === 0 || code.length > 6) {
        return;
      }
      if (authContext.mfaRequired)
        try {
          await authContext.sendMfaCode(email, code);
          setCode('');
          authContext.setEmail('');
          navigate(PAGES.landing);
        } catch (error: any) {
          setGenericErrorMessage(error.message);
          setOpen(true);
          setInProgress(false);
        }
      else
        try {
          await authContext.sendCode(email, code);
          setCode('');
          await authContext.signInWithEmail(email, passwordAdvance);
          if (!authContext.isMultifactor) {
            navigate(PAGES.home);
          } else {
            setInProgress(false);
          }
        } catch (error: any) {
          if (error.code === 'NotAuthorizedException') {
            navigate(PAGES.landing);
          }
          setGenericErrorMessage(error.message);
          setOpen(true);
          setInProgress(false);
        }
    }
  };

  const isButtonDisabled = () => {
    return codeIsValid !== '' || inProgress;
  };

  return (
    <Grid
      container
      justifyContent='center'
      alignContent='center'
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Grid item xl={4} lg={4} md={5} sm={6} xs={12}>
        {/* <div style={backDivStyle}>
          <a style={backStyle} onClick={(e: any) => navigate(-1)}>
            Back
          </a>
        </div> */}
        <Paper elevation={0} style={paperStyle}>
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <Header
              text1='Verify e-mail'
              text2='We have sent a 6 digit code to your email Please enter
              verification code'
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <ReactCodeInput
              type='text'
              fields={6}
              name='anyName'
              inputMode='tel'
              onChange={(e: any) => setCode(e)}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ ...labelStyle, marginBottom: '16px', marginTop: '16px' }}
          >
            <Typography>
              <Link onClick={(e) => onReSendCode(e)} to='' style={pLabelStyle}>
                Resend Invite Code
              </Link>
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              style={isButtonDisabled() ? btnStyle : btnStyleActive}
              fullWidth
              onClick={(e) => {
                sendCode(e);
              }}
              disabled={isButtonDisabled()}
            >
              Submit
            </Button>
          </Grid>
        </Paper>
        <Grid
          item
          xs={12}
          md={12}
          xl={12}
          style={{ ...labelStyle, marginTop: '40px' }}
        >
          <Typography style={{ ...pLabelDarkerStyle, color: 'white' }}>
            Did not receive the email? Check your spam filter
          </Typography>
        </Grid>
      </Grid>
      <Notif open={open} setOpen={setOpen} message={genericErrorMessage} />
    </Grid>
  );
};

export default VerifyAccount;
